import { Field } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import EquipmentGpsTrackerPicker, {
  IEquipmentGpsTrackerPickerProps,
} from '../EquipmentGpsTrackerPicker/EquipmentGpsTrackerPicker';

export interface IEquipmentGpsTrackerFormFieldProps
  extends Omit<IEquipmentGpsTrackerPickerProps, 'value' | 'onSelect'> {
  className?: ClassName;
  form: any;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
}

const EquipmentGpsTrackerFormField = (props: IEquipmentGpsTrackerFormFieldProps) => {
  const { className, form, name, onChange, validations, ...other } = props;

  const classes = classNames('equipment-gps-tracker-form-field', className);

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }
    return <EquipmentGpsTrackerPicker onSelect={handleOnSelect} value={form.state.data[name]} {...other} />;
  }
  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
};

export default EquipmentGpsTrackerFormField;
